import { containerless } from 'aurelia-framework';

@containerless
export class VoltoContainerButtons {
}